import { Huddle, HuddleStatus, User } from 'lib/generated/graphql';
import { ReactNode, useRef } from 'react';
import CreateRequest from 'src/screens/my-projects/components/CreateLegacyRequest';
import { Button, Modal } from 'src/shared-components';
import HuddleCard from 'src/shared-components/HuddleCard/Huddle';
import PageContainer from 'src/shared-components/Layout/PageContainer';

const HuddlesContainer = ({
  status,
  children,
  customer,
  user,
}: {
  status?: HuddleStatus;
  children: ReactNode;
  customer?: boolean;
  user?: User;
}) => {
  const modalCreateProjectRef = useRef<any>();
  const handleOpenCreateProjectModal = () => {
    modalCreateProjectRef.current?.open();
  };

  return (
    <PageContainer title="My Huddles">
      <div className="mb-24 max-w-5xl">
        {customer && (
          <div className="sm:flex">
            <div className="ml-auto pt-4 sm:pt-0">
              <Button color="white" onClick={handleOpenCreateProjectModal} size="lg">
                + Request a Huddle
              </Button>
            </div>
          </div>
        )}
        <div className="">{children}</div>
      </div>
      <Modal ref={modalCreateProjectRef} closeButtonForStepper closeOnBackdropClick={false}>
        {user?.companies && user?.companies.length > 0 ? (
          <CreateRequest
            companyId={user?.companies[0]?.id}
            onRequestCreated={() => modalCreateProjectRef.current.close()}
          />
        ) : (
          <>You need to create a company first</>
        )}
      </Modal>
    </PageContainer>
  );
};

export const MyHuddlesMap = ({
  huddles,
  noHuddlesText,
  count,
  optedIn = false,
  selected = false,
  customer = false,
}: {
  huddles: any;
  noHuddlesText?: string;
  count?: number;
  optedIn?: boolean;
  selected?: boolean;
  customer?: boolean;
}) => {
  return huddles?.length > 0
    ? huddles.map((huddle: Huddle) => (
        <HuddleCard
          myHuddlesView
          key={huddle.id}
          huddle={huddle}
          className="mb-10"
          navigateToUserView
          myHuddlesViewOptedIn={optedIn}
          myHuddlesViewSelected={selected}
          suggestion={optedIn}
          customersMyHuddleView={customer}
        />
      ))
    : count === 0 && <div className="text-[#595959] text-[20px] my-4">{noHuddlesText}</div>;
};

export default HuddlesContainer;
